import './../main.js'
import { createApp } from 'vue'
import BookingBar from './apps/BookingBar.vue'
import BookingStep1 from './apps/BookingStep1.vue'
import BookingStep2 from './apps/BookingStep2.vue'
import BookingStep3 from './apps/BookingStep3.vue'
import BookingStep4 from './apps/BookingStep4.vue'
import BookingModify from './apps/BookingModify.vue'
import BookingModifyCancel from './apps/BookingModifyCancel.vue'
import BookingModifyReview from './apps/BookingModifyReview.vue'
import BookingModifyResume from './apps/BookingModifyResume.vue'
import BookingModifyRefund from './apps/BookingModifyRefund.vue'
import BookingModifySearch from './apps/BookingModifySearch.vue'
import SolutionsSlick from './apps/SolutionsSlick.vue'
import OffersSlick from './apps/OffersSlick.vue'
import Services from './apps/Services.vue'
import ServicesSlick from './apps/ServicesSlick.vue'
import ProgrammsSlick from './apps/ProgrammsSlick.vue'
import SolutionsWizard from './apps/SolutionsWizard.vue'
import Fleet from './apps/Fleet.vue'
import FleetPage from './apps/FleetPage.vue'
import MenuMobile from './apps/MenuMobile.vue'
import ForgotPassword from './apps/ForgotPassword.vue'
import Login from './apps/Login.vue'
import Register from './apps/Register.vue'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import { setupCalendar } from 'v-calendar'
import Destinations from './apps/Destinations.vue'
import DestinationsSlick from './apps/DestinationsSlick.vue'
import HighlightsSlick from './apps/HighlightsSlick.vue'
import VideosSlick from './apps/VideosSlick.vue'
import StoresSlick from './apps/StoresSlick.vue'
import GallerySlick from './apps/GallerySlick.vue'
import FleetFlexDrive from './apps/FleetFlexDrive.vue'
import FleetLeasing from './apps/FleetLeasing.vue'
import LeaseItNowCalculator from './apps/LeaseItNowCalculator.vue'
import LeasingBonusSlick from './apps/LeasingBonusSlick.vue'
import LeaseItNow from './apps/LeaseItNow.vue'
import FlexDriveVehicle from './apps/FlexDriveVehicle.vue'
import FlexDriveBookingRequest from './apps/FlexDriveBookingRequest.vue'
import LeasingCompareOffers from './apps/LeasingCompareOffers.vue'
import LeasingCompareSaver from './apps/LeasingCompareSaver.vue'
import FleetLeasingPage from './apps/FleetLeasingPage.vue'
import LeasingCar from './apps/LeasingCar.vue'
import LeasingCarSaver from './apps/LeasingCarSaver.vue'
// stores
import flexDriveStore from './stores/flexdrive.js'
import storeLeasingOffers from './stores/store-leasingOffers.js'
import storeLeaseItNow from './stores/store-leaseitnow.js'
// router
import routerLeaseItNow from './router/router-leaseitnow.js'
import Stores from './apps/Stores.vue'
import News from './apps/News.vue'
import CarSales from './apps/CarSales.vue'
import Contact from './apps/Contact.vue'
import QuotationRequest from './apps/QuotationRequest.vue'
import LeasingContactForm from './apps/LeasingContactForm.vue'
import FeaturedSlick from './apps/FeaturedSlick.vue'
import FlexDriveExclusivesSlick from './apps/FlexDriveExclusivesSlick.vue'
import FlexDriveSuccess from './apps/FlexDriveSuccess.vue'
import MilesAndBonusModal from './apps/MilesAndBonusModal.vue'
import VideosEquipmentSlick from './apps/VideosEquipmentSlick.vue'

if (document.getElementById('app-booking-bar')) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingBar)
    .use(autoAnimatePlugin)
    .use(setupCalendar, {})

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-booking-bar')
}

if (document.getElementById('app-booking-step1')) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingStep1).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-booking-step1')
}

if (document.getElementById('app-booking-step2')) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingStep2).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-booking-step2')
}

if (document.getElementById('app-booking-step3')) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingStep3).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-booking-step3')
}

if (document.getElementById('app-booking-step4')) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingStep4).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-booking-step4')
}

if (document.getElementById('app-booking-modify')) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingModify)
    .use(autoAnimatePlugin)
    .use(setupCalendar, {})

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-booking-modify')
}

if (document.getElementById('app-booking-modify-cancel')) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingModifyCancel)
    .use(autoAnimatePlugin)
    .use(setupCalendar, {})

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-booking-modify-cancel')
}

if (document.getElementById('app-booking-modify-review')) {
  const { dictionary } = window['bookingData']
  const app = createApp(BookingModifyReview)
    .use(autoAnimatePlugin)
    .use(setupCalendar, {})

  Object.assign(app.config.globalProperties, { dictionary: dictionary })

  app.mount('#app-booking-modify-review')
}

if (document.getElementById('app-booking-modify-resume')) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingModifyResume)
    .use(autoAnimatePlugin)
    .use(setupCalendar, {})

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-booking-modify-resume')
}

if (document.getElementById('app-booking-modify-refund')) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingModifyRefund)
    .use(autoAnimatePlugin)
    .use(setupCalendar, {})

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-booking-modify-refund')
}

if (document.getElementById('app-booking-modify-search')) {
  const { dictionary, configuration } = window['bookingData']
  const app = createApp(BookingModifySearch)
    .use(autoAnimatePlugin)
    .use(setupCalendar, {})

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-booking-modify-search')
}

if (document.getElementById('app-solutions-slick')) {
  const { configuration } = window['solutionsData']
  const app = createApp(SolutionsSlick)

  Object.assign(app.config.globalProperties, { configuration: configuration })

  app.mount('#app-solutions-slick')
}

if (document.getElementById('app-offers-slick')) {
  createApp(OffersSlick).mount('#app-offers-slick')
}

if (document.getElementById('app-leasing-bonus-slick')) {
  const { configuration } = window['leasingBonusSlickData']
  const app = createApp(LeasingBonusSlick)

  Object.assign(app.config.globalProperties, { configuration: configuration })
  app.mount('#app-leasing-bonus-slick')
}

if (document.getElementById('app-services')) {
  createApp(Services).use(autoAnimatePlugin).mount('#app-services')
}

if (document.getElementById('app-services-slick')) {
  createApp(ServicesSlick).use(autoAnimatePlugin).mount('#app-services-slick')
}

if (document.getElementById('app-programms-slick')) {
  createApp(ProgrammsSlick).use(autoAnimatePlugin).mount('#app-programms-slick')
}

if (document.getElementById('app-solutions-wizard')) {
  const { dictionary } = window['solutionsWizard']
  const app = createApp(SolutionsWizard)

  Object.assign(app.config.globalProperties, { dictionary: dictionary })
  app.mount('#app-solutions-wizard')
}

createApp(MenuMobile).use(autoAnimatePlugin).mount('#app-menu-mobile')

if (document.getElementById('app-forgot-password')) {
  const { dictionary, configuration } = window['forgotPasswordData']
  const app = createApp(ForgotPassword)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-forgot-password')
}

if (document.getElementById('app-login')) {
  const { dictionary, configuration } = window['loginData']
  const app = createApp(Login)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-login')
}

if (document.getElementById('app-register')) {
  const { dictionary, configuration } = window['registerData']
  const app = createApp(Register)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-register')
}

if (document.getElementById('app-fleet')) {
  const { dictionary, configuration } = window['fleetData']
  const app = createApp(Fleet).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-fleet')
}

if (document.getElementById('app-fleet-page')) {
  const { dictionary, configuration } = window['fleetData']
  const app = createApp(FleetPage).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-fleet-page')
}

if (document.getElementById('app-destinations')) {
  const { dictionary, configuration } = window['destinationsData']
  const app = createApp(Destinations).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-destinations')
}

if (document.getElementById('app-destinations-slick')) {
  const { dictionary } = window['destinationsData']
  const app = createApp(DestinationsSlick)

  Object.assign(app.config.globalProperties, { dictionary: dictionary })

  app.mount('#app-destinations-slick')
}

Array.from(document.querySelectorAll('.app-highlights-slick')).map((i) => {
  const appId = i.id

  const appHighlightsSlick = createApp(HighlightsSlick)

  Object.assign(appHighlightsSlick.config.globalProperties, { appId: appId })

  appHighlightsSlick.mount(`#${appId}`)
})

if (document.getElementById('app-videos-slick')) {
  const { dictionary } = window['videosData']
  const app = createApp(VideosSlick)

  Object.assign(app.config.globalProperties, { dictionary: dictionary })

  app.mount('#app-videos-slick')
}

if (document.getElementById('app-stores-slick')) {
  const { dictionary } = window['storesData']
  const app = createApp(StoresSlick)

  Object.assign(app.config.globalProperties, { dictionary: dictionary })

  app.mount('#app-stores-slick')
}

if (document.getElementById('app-gallery-slick')) {
  createApp(GallerySlick).mount('#app-gallery-slick')
}

if (document.getElementById('app-fleet-flexdrive')) {
  const { dictionary, configuration } = window['fleetData']
  const app = createApp(FleetFlexDrive)
    .use(autoAnimatePlugin)
    .use(flexDriveStore)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-fleet-flexdrive')
}

if (document.getElementById('app-fleet-leasing')) {
  const { dictionary, configuration } = window['fleetData']
  const app = createApp(FleetLeasing).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-fleet-leasing')
}

if (document.getElementById('app-leaseitnow-calculator')) {
  const { dictionary, configuration } = window['leaseItNowCalculatorData']
  const app = createApp(LeaseItNowCalculator)
    .use(autoAnimatePlugin)
    .use(storeLeaseItNow)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-leaseitnow-calculator')
}

if (document.getElementById('app-leaseitnow')) {
  const { dictionary, configuration } = window['leaseItNowData']
  const app = createApp(LeaseItNow)
    .use(autoAnimatePlugin)
    .use(storeLeaseItNow)
    .use(routerLeaseItNow)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-leaseitnow')
}

if (document.getElementById('app-flexdrive-vehicle')) {
  const { dictionary, configuration } = window['flexDriveVehicleData']
  const app = createApp(FlexDriveVehicle).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-flexdrive-vehicle')
}

if (document.getElementById('app-flexdrive-booking-request')) {
  const { dictionary, configuration } = window['flexDriveBookingData']
  const app = createApp(FlexDriveBookingRequest).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-flexdrive-booking-request')
}

if (document.getElementById('app-fleet-leasing-page')) {
  const { dictionary, configuration } = window['fleetData']
  const app = createApp(FleetLeasingPage)
    .use(autoAnimatePlugin)
    .use(storeLeasingOffers)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-fleet-leasing-page')
}

if (document.getElementById('app-leasing-compare-offers')) {
  const { dictionary, configuration } = window['leasingCompareData']
  const app = createApp(LeasingCompareOffers)
    .use(autoAnimatePlugin)
    .use(storeLeasingOffers)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-leasing-compare-offers')
}
if (document.getElementById('app-leasing-compare-saver')) {
  const { dictionary, configuration } = window['leasingCompareData']
  const app = createApp(LeasingCompareSaver)
    .use(autoAnimatePlugin)
    .use(storeLeasingOffers)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-leasing-compare-saver')
}
if (document.getElementById('app-leasing-car')) {
  const { dictionary, configuration } = window['leasingCarData']
  const app = createApp(LeasingCar).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-leasing-car')
}
if (document.getElementById('app-leasing-car-saver')) {
  const { dictionary, configuration } = window['leasingCarSaverData']
  const app = createApp(LeasingCarSaver).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-leasing-car-saver')
}

if (document.getElementById('app-stores')) {
  const { dictionary, configuration } = window['storesData']
  const app = createApp(Stores).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-stores')
}

if (document.getElementById('app-news')) {
  const { dictionary, configuration } = window['newsData']
  const app = createApp(News).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-news')
}

if (document.getElementById('app-car-sales')) {
  const { dictionary, configuration } = window['carSalesData']
  const app = createApp(CarSales).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-car-sales')
}

if (document.getElementById('app-contact')) {
  const { dictionary, configuration } = window['contactData']
  const app = createApp(Contact).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-contact')
}

if (document.getElementById('app-quotation-request')) {
  const { dictionary, configuration } = window['quotationData']
  const app = createApp(QuotationRequest).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-quotation-request')
}

if (document.getElementById('app-leasing-contact-form')) {
  const { dictionary, configuration } = window['contactFormData']
  const app = createApp(LeasingContactForm).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-leasing-contact-form')
}

import BestSellersSlick from './apps/BestSellersSlick.vue'

if (document.getElementById('app-best-sellers-slick')) {
  const { dictionary, configuration } = window['bestSellersData']
  const app = createApp(BestSellersSlick).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-best-sellers-slick')
}
if (document.getElementById('app-featured-slick')) {
  const { dictionary, configuration } = window['featuredData']
  const app = createApp(FeaturedSlick).use(autoAnimatePlugin)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-featured-slick')
}
if (document.getElementById('app-flexdrive-success')) {
  const { dictionary } = window['flexDriveBookingData']
  const app = createApp(FlexDriveSuccess).use(autoAnimatePlugin)

  Object.assign(app.config.globalProperties, { dictionary: dictionary })

  app.mount('#app-flexdrive-success')
}

if (document.getElementById('app-flexdrive-exclusives-slick')) {
  createApp(FlexDriveExclusivesSlick).mount('#app-flexdrive-exclusives-slick')
}

if (document.getElementById('app-miles-and-bonus-modal')) {
  const { dictionary, configuration } = window['milesNBonusData']
  const app = createApp(MilesAndBonusModal)

  Object.assign(
    app.config.globalProperties,
    { dictionary: dictionary },
    { configuration: configuration }
  )

  app.mount('#app-miles-and-bonus-modal')
}

Array.from(document.querySelectorAll('.app-videos-equipment-slick')).map(
  (i) => {
    const appId = i.id

    const appVideosEquipmentSlick = createApp(VideosEquipmentSlick)

    Object.assign(appVideosEquipmentSlick.config.globalProperties, {
      appId: appId,
    })

    appVideosEquipmentSlick.mount(`#${appId}`)
  }
)
